import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconInfoConvRestart.tsx
const IconInfoConvRestart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsxs("g", {
			fill: "#998e8e",
			clipPath: "url(#a)",
			children: [
				/* @__PURE__ */ jsx("path", { d: "M14 2v2H9v4H5v12h14v-8h2v9.009a.993.993 0 0 1-.993.991H3.993A1 1 0 0 1 3 20.993V7l5-5zm-1 16h-2v-6h2zm0-8h-2V8h2z" }),
				/* @__PURE__ */ jsx("path", {
					fillRule: "evenodd",
					d: "M24 5.994V6c0 1.45-.77 2.719-1.925 3.42zM16 5.995c0-1.45.772-2.72 1.928-3.422z",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("path", {
					fillRule: "evenodd",
					d: "M16 6a4 4 0 0 0 4 4V8a2 2 0 0 1-2-2c0-.542-.42-3.063-.071-3.423A4 4 0 0 0 16 6m4-4v2a2 2 0 0 1 2 2v.001c0 .54.423 3.06.075 3.42A4 4 0 0 0 20 2",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("path", { d: "m18 5.99 1.5.01-1.571-3.423c-.347.358.074 2.875.071 3.412M22 6v-.006L20.5 6l1.575 3.42C22.423 9.06 22 6.54 22 6z" })
			]
		}),
		/* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M0 0h24v24H0z"
			})
		}) })
	]
});
var IconInfoConvRestart_default = forwardRef(IconInfoConvRestart);
//#endregion
export { IconInfoConvRestart_default as default };
